module.exports = __webpack_public_path__ + "static/media/sickness_injury-min.db212726.jpg";